import API from '../../services/API';
import { setError, startSpinner, stopSpinner } from '../common/actionCreators';
import { configs } from '../../constants/configs/configs';
import { FEATURE_PLAN_ACTION_TYPES } from '../../constants/actionTypes/featurePlanActionTypes';

export const setfeaturePlanList = data => ({
    type: FEATURE_PLAN_ACTION_TYPES.SET_FEATURE_PLAN_LIST,
    payload: data,
});

export const setUploadTemplateSuccessMsg = data => ({
    type: FEATURE_PLAN_ACTION_TYPES.SET_UPLOAD_TEMPLATE_SUCCESS_MESSAGE,
    payload: data,
});

export const setUploadTemplateErrorMsg = data => ({
    type: FEATURE_PLAN_ACTION_TYPES.SET_UPLOAD_TEMPLATE_ERROR_MESSAGE,
    payload: data,
});

export const setUploadTemplateFailureMsg = data => ({
    type: FEATURE_PLAN_ACTION_TYPES.SET_UPLOAD_TEMPLATE_FAILURE_MESSAGE,
    payload: data,
});

export const setSidebarParams = data => ({
    type: FEATURE_PLAN_ACTION_TYPES.SET_SIDEBAR_PARAMS,
    payload: data,
});

export const setCurrentYear = data => ({
    type: FEATURE_PLAN_ACTION_TYPES.SET_CURRENT_YEAR,
    payload: data,
});


const actions = { setError, startSpinner, stopSpinner };

export const getFeaturePlanList = (encIssuerId, postUpload = false, showUploadedMsg = false) => async (dispatch: Function) => {
    try {
        const url = configs.endpoints.FEATURE_PLAN_LIST.processReplacements({ encIssuerId });
        const featurePlanListResponse = await API.getData(url, dispatch, actions);
        if (featurePlanListResponse?.data) {
            const { serffDocList, year } = featurePlanListResponse.data; 
            dispatch(setfeaturePlanList(serffDocList));
            dispatch(setCurrentYear(year));
            if(postUpload) {
                if(showUploadedMsg) {
                    dispatch(setUploadTemplateSuccessMsg('issuer.featuretemplate.success.uploaddocument'));
                } else {
                    dispatch(setUploadTemplateFailureMsg('issuer.featuretemplate.failure.uploaddocument'));
                }
            }
        } else {
            console.error('Cannot getFeaturePlans', url);
        }
    } catch (error) {
        console.error('Cannot getFeaturePlans', error);
    }
};

export const uploadFeatureTemplate = (encIssuerId, payload) => async dispatch => {
    try {
        const url = configs.endpoints.FEATURE_PLAN_UPLOAD_TEMPLATE.processReplacements({ encIssuerId });
        const params = [url, payload, undefined, false, undefined, 'multipart/form-data'];
        const uploadTemplateResponse = await API.postData(params, dispatch, actions);
        if(uploadTemplateResponse && uploadTemplateResponse.status === 'success') {
            dispatch(getFeaturePlanList(encIssuerId, true, uploadTemplateResponse.status === 'success'));
        }
        else {
            dispatch(getFeaturePlanList(encIssuerId, true));
        }
    } catch(error) {
        dispatch(setUploadTemplateFailureMsg('issuer.featuretemplate.failure.uploaddocument'));
    }
};
